<template>
  <div style="width: 100%; margin: 0 auto">
    <div class="body_top">
      <div class="bg_img_div">
        <!-- <img src="@/assets/newYXSCbg22.png" /> -->
      </div>
      <!-- 绝对定位 -->
      <div class="body_top_abs">
        <div class="img_he">
          <img class="log_Img" :src="require('@/assets/herder_logo1.png')" alt="" />
          <p class="bt1">同城租赁 高效共享</p>
          <div class="ss_abs_center">
            <div class="ss_abs_c_srk">
              <input v-model="from1.keyWord" @keyup.enter="getList" placeholder="输入器材名称等进行搜索" />
              <div @click="getList()" class="cur">
                <img src="@/assets/yxsc_ss.png" />
                搜索
              </div>
            </div>
            <span class="ss_abs_c_center">或</span>
            <div @click="showReleaseLease" class="ss_abs_c_right cur">
              发布器材信息
            </div>
          </div>
          <div class="log_box">
            <!-- <img src="@/assets/log1.png" />
            <p>x</p>
            <img src="@/assets/log2.png" />
            <p>x</p>
            <img src="@/assets/log3.png" /> -->
          </div>
        </div>
      </div>
    </div>
    <div class="body_main">
      <div class="moduleImageList">
        <el-row :gutter="20">
          <el-col :span="6" v-for="(item, index) in list" @click="goProductInformationClick(item.id)" :key="index">
            <moduleImageList class="cur" :item="item"></moduleImageList>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-dialog style="margin-top: 0.3rem" title="发布器材信息" v-model="checked" align-center :close-on-click-modal="false"
      :before-close="handleClose" width="800px">
      <el-form :model="form" label-width="100px" ref="formRef" :rules="rules">
        <el-form-item label="封面" prop="url">
          <el-upload v-if="fileList.length == 0" class="upload-demo" :action="upload_action" :on-change="handleChange"
            :on-success="onSuccess" :on-progress="onProgress" :on-remove="handleRemove" :show-file-list="false"
            ref="upload" :file-list="fileList" :limit="1" drag>
            <!--  :action="serverBaseUrl + '/dev-api/file/upload'"
            :headers="header" -->
            <el-icon class="el-icon--upload">
              <div style="
                  width: 0.2rem;
                  height: 0.2rem;
                  background: url(data:image/png;base64,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);
                  background-size: 100%;
                  background-repeat: no-repeat;
                "></div>
            </el-icon>
            <div class="el-upload__text">
              <div style="font-size: 0.14rem; color: #333333">
                点击或拖拽文件到此处上传
              </div>
              <div style="font-size: 0.12rem; color: #86909c">
                图片比例建议1:1
              </div>
            </div>
          </el-upload>
          <div v-if="fileList.length" style="
              background: #ccc;
              text-align: center;
              width: 150px;
              height: 150px;
            ">
            <el-image style="width: 150px; height: 150px" fit="fit" :src="fileList[0].url"
              :preview-src-list="[fileList[0].url]">
            </el-image>
            <div class="img-text">
              {{
                fileList[0].name1.match(regex)[1] +
                "" +
                fileList[0].name1.match(regex)[2]
              }}
            </div>
            <el-image :src="url" @click="handleRemove(fileList[0].url)" class="img-Off" />
          </div>
        </el-form-item>
        <el-form-item label="器材细节" prop="url1">
          <div style="display: flex" class="he">
            <div v-for="(item, index) in fileList1" :key="index" class="he1">
              <el-image class="img" v-if="index == 0" :src="item.url" style="" :key="index"
                :preview-src-list="fileList1.map((e) => e.url)" fit="cover" :initial-index="index" />
              <div class="he2">
                <el-image class="img" v-if="index != 0" :src="item.url" style="" :key="index"
                  :preview-src-list="fileList1.map((e) => e.url)" fit="cover" :initial-index="index" />
                <el-image :key="index" v-if="index != 0" :src="url" @click="handleRemove2(index)" class="img-Off1" />
              </div>
              <el-image :key="index" v-if="index == 0" :src="url" @click="handleRemove2(index)" class="img-Off1" />
            </div>
            <div class="img_he1" v-for="index in 6 - fileList1.length" :style="fileList1.length == 0
              ? index !== 1
                ? 'margin-left: 20px'
                : ''
              : 'margin-left: 20px'
              " :key="index" @click="() => uploadImage(index)">
              <el-icon>
                <Plus />
              </el-icon>
              <input type="file" :ref="setFileInputRef(index)" @change="handleFileChange" style="display: none" />
            </div>
          </div>
        </el-form-item>
        <el-form-item label="器材名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入器材名称" />
        </el-form-item>
        <el-form-item label="配置说明" prop="description">
          <el-input type="textarea" v-model="form.description" placeholder="请填写配置说明" />
        </el-form-item>
        <el-form-item label="联系方式" prop="contactInformation">
          <el-input v-model="form.contactInformation" placeholder="请填写手机号/邮箱等联系方式" />
        </el-form-item>
      </el-form>
      <div style="color: #86909c; margin-left: 0.2rem">
        请填写器材设备相关信息，切勿发布不实信息或违法信息
      </div>
      <div style="display: flex; justify-content: center; margin-top: 10px">
        <div class="dataBtn dataBtnQx" @click="handleClose(false)">取消</div>
        <div class="dataBtn" @click="submitForm()">确认发布</div>
      </div>
    </el-dialog>
    <div style="display: flex; justify-content: center; margin-top: 10px">
      <div style="margin-top: 0.4rem; margin-bottom: 0.6rem">
        <el-pagination v-if="list.length != 0" v-model:current-page="from1.pageIndex" v-model:page-size="from1.pageSize"
          @size-change="sizeChange" @current-change="currentChange" style="margin: 0.4rem 0" background
          layout="prev, pager, next" :total="from1.total" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, reactive } from "vue";
import { useRouter } from "vue-router";
import moduleImageList from "../../components/moduleImageList.vue";
import type { FormInstance, FormRules } from "element-plus";
import { Axios } from "../../assets/js/ls_com_axios.js";
import { ElMessage, ElLoading } from "element-plus";
import uploadByPieces from "@/assets/js/uploadNew";
import { serverBaseUrl } from "../../assets/js/ls_tgServerUrls.js";
import url from "@/assets/module_share_open.png";
document.title = "标识山西-找器材";
const upload_action = ref(serverBaseUrl + "/file/upload");
const router = useRouter();
const list = ref([]);
const from1 = ref({
  keyWord: "",
  pageIndex: 1,
  pageSize: 8,
  total: 0,
});
const upload = ref<any>();
const upload1 = ref<any>();
const fileList = ref([]);
const fileList1 = ref([]);
let loading = ref(false);

const header = ref({
  Authorization: "Bearer " + localStorage.getItem("token"),
});
// 跳列表页
// const goPagelink = function() {
// 	router.push({
// 		path: '/ShadowTrainList',
// 	})
// }
/* 服务器异常 */
/* 获取数据列表 */
const sizeChange = function (val) {
  getList();
};
const currentChange = function (val) {
  getList();
};
const getList = function () {
  Axios(
    "POST",
    "/material/material/equipment/list",
    from1.value,
    false,
    function (res) {
      if (res.data.code == 200) {
        list.value = res.data.data.records;
        from1.value.total = res.data.data.total;
        console.log(list);
      } else {
        ElMessage.error(res.data.message);
      }
    }
  );
};
// /material/material/equipment/list
const goProductInformationClick = function (id) {
  router.push({
    path: "/moduleImageInformation",
    query: { id: id },
  });
};
const checked = ref(false);
// const bodyStyle = document.body.style;
const showReleaseLease = function () {
  // return console.log(JSON.parse(localStorage.getItem("userList")));
  console.log(JSON.parse(localStorage.getItem("userList")));
  if (JSON.parse(localStorage.getItem("userList"))) {
    checked.value = true;
  } else {
    router.push({
      path: "/TgLogin",
    });
  }
};
const openWindow = function () {
  // bodyStyle.overflowY = 'auto';
  checked.value = false;
};
const handleSuccess = function (respons, uploadFile, uploadFiles) {
  console.log(respons, uploadFile, uploadFiles);
};
const fileInputs = ref([]);
const setFileInputRef = (index) => {
  return (el) => {
    fileInputs.value[index] = el;
  };
};
const uploadImage = (index) => {
  // fileInput.value.click();
  if (fileInputs.value[index]) {
    fileInputs.value[index].click();
  }
  // console.log(fileInputs.value[index]);
  // console.log(fileInput.value);
};

const handleFileChange = (event: any) => {
  const file = event.target.files[0];
  if (!file) return;

  // Checking the file extension
  const fileExtension = file.name.split(".").pop().toLowerCase();
  if (!allowedExtensions.includes("." + fileExtension)) {
    return ElMessage.warning("格式不正确");
  }
  // console.log(file);
  handleFileChange1(file);
  // Reset the input after handling the file
  event.target.value = null;
};
const handleRemove2 = (index) => {
  console.log(index);

  fileList1.value.splice(index, 1);
};
const handleFileChange1 = (file) => {
  loading.value = ElLoading.service({
    lock: true,
    text: "Loading",
    background: "rgba(0, 0, 0, 0.7)",
  });
  const formData = new FormData();
  formData.append("file", file);
  Axios(
    "POST",
    "/file/upload",
    formData,
    false,
    function (res) {
      if (res.data.code == 200) {
        // handleClose(true);
        fileList1.value.push({
          url: res.data.data.url,
          name: res.data.data.url,
        });
        form.value.url1.push({ url: res.data.url });
        loading.value.close();
      } else {
        ElMessage.error(res.data.message);
      }
    },
    false,
    1
  );
};
const dialogVisible = ref(false);
const dialogImageUrl = ref("");
const uploadImage1 = (index: any) => {
  dialogVisible.value = true;
  dialogImageUrl.value = fileList1.value[index].url;
};
/* *** from 表单 *** */
const allowedExtensions = [".png", ".jpg", ".jpeg"];
const fileName = ref("");
const percentageValue = ref(0);
const onProgress = () => {
  loading.value = ElLoading.service({
    lock: true,
    text: "Loading",
    background: "rgba(0, 0, 0, 0.7)",
  });
};
// 上传前
const handleChange = (uploadFile: any, uploadFiles: any) => {
  if (
    allowedExtensions.indexOf(
      uploadFile.name
        .substring(uploadFile.name.lastIndexOf("."))
        .toLocaleLowerCase()
    ) == -1
  ) {
    // fileList.value.splice(fileList.value.length, 1);
    // console.log();
    upload.value.handleRemove(uploadFile, 1);
    ElMessage.warning("格式不正确");
    return;
  }
  // if (fileList.value.length == 1) {
  //   upload.value.handleRemove(uploadFile, 1);
  //   return ElMessage.warning("只能上传一个图片");
  // }
  // const timestamp = Date.now();
  // percentageValue.value = 0;
  // fileName.value = uploadFile.name;
  // uploadByPieces(
  //   timestamp,
  //   uploadFile.raw,
  //   5,
  //   3,
  //   (res: any) => {
  //     percentageValue.value = 100;
  //     // filePath.value = res.data.url;
  //     fileList.value.push({
  //       url: res.data.url,
  //       name: fileName.value,
  //     });
  //     console.log(fileList);
  //   },
  //   (p: any) => {
  //     percentageValue.value = p;
  //   },
  //   (error: any) => {
  //     console.error(error);
  //   }
  // );
};
const handleExceed = (files: any, fileList1: any) => {
  return ElMessage.warning("只能上传一个图片");
};
// 上传成功
const onSuccess = (res: any, file: any, fileList1: any) => {
  fileList.value.push({
    url: res.data.url,
    name: res.data.name,
    name1: res.data.name.split("?")[0],
  });
  form.value.url = res.data.url;
  loading.value.close();
  console.log(fileList.value);
};
// // 删除图片
const handleRemove = (file, fileList1, type) => {
  fileList.value.splice(
    fileList.value.findIndex((item) => item.url === file.url),
    1
  );
  form.value.url = null;
};
// 上传1
const handleChange1 = (uploadFile: any, uploadFiles: any) => {
  if (
    allowedExtensions.indexOf(
      uploadFile.name
        .substring(uploadFile.name.lastIndexOf("."))
        .toLocaleLowerCase()
    ) == -1
  ) {
    // fileList.value.splice(fileList.value.length, 1);
    // console.log();
    upload1.value.handleRemove(uploadFile, 1);
    ElMessage.warning("格式不正确");
    return;
  }
  // if (fileList1.value.length == 2) {
  //   upload1.value.handleRemove(uploadFile, 1);
  //   return ElMessage.warning("只能上传两个图片");
  // }
  // const timestamp = Date.now();
  // percentageValue.value = 0;
  // fileName.value = uploadFile.name;
  // uploadByPieces(
  //   timestamp,
  //   uploadFile.raw,
  //   5,
  //   3,
  //   (res: any) => {
  //     percentageValue.value = 100;
  //     // filePath.value = res.data.url;
  //     fileList1.value.push({
  //       url: res.data.url,
  //       name: fileName.value,
  //     });
  //     console.log(fileList1);
  //   },
  //   (p: any) => {
  //     percentageValue.value = p;
  //   },
  //   (error: any) => {
  //     console.error(error);
  //   }
  // );
};
// 上传成功1
const onSuccess1 = (res: any, file: any, fileList: any) => {
  fileList1.value.push({
    url: res.data.url,
    name: res.data.url,
  });
  form.value.url1.push({ url: res.data.url });
  loading.value.close();
};
// // 删除图片1
const handleRemove1 = (file, type) => {
  fileList1.value.splice(
    fileList1.value.findIndex((item) => item.url === file.url),
    1
  );
  form.value.url1.splice(
    fileList1.value.findIndex((item) => item.url === file.url),
    1
  );
};
const handleExceed1 = (files: any, fileList1: any) => {
  return ElMessage.warning("只能上传六个图片");
};
const regex = /(.+)_.*(\..+)/;
// 发布
const form = ref<Form>({
  contactInformation: "",
  coverSheet: "",
  name: null,
  url: "",
  description: "",
  url1: [],
});
type Form = {
  contactInformation: string;
  coverSheet: string;
  name: string;
  description: string;
};
type Rules = {
  [K in keyof Form]?: Array<FormItemRule>;
};
const rules = reactive<FormRules<Rules>>({
  contactInformation: [
    { required: true, message: "请输入联系方式", trigger: "change" },
  ],
  coverSheet: [{ required: true, message: "请输入封面", trigger: "change" }],
  name: [{ required: true, message: "请输入名称", trigger: "change" }],
  description: [
    { required: true, message: "请输入描述说明", trigger: "change" },
  ],
  url: [{ required: true, message: "请上传传封面", trigger: "change" }],
  url1: [{ required: true, message: "请上传器材细节", trigger: "change" }],
});
const formRef = ref<any>();
//  表单提交取消
const submitForm = () => {
  formRef.value.validate(async (valid: boolean) => {
    if (valid) {
      let obj = { ...form.value };
      if (fileList.value.length == 0) {
        return ElMessage.warning("请上传封面");
      }
      if (fileList1.value.length == 0) {
        return ElMessage.warning("器材细节");
      }
      obj.coverSheet = fileList.value[0].url;
      // obj.type = fileList.value[0].name.substring(
      // fileList.value[0].name.lastIndexOf(".") + 1
      // );
      let fileList1S = JSON.parse(JSON.stringify(fileList1.value));
      fileList1S.push(fileList.value[0]);
      obj.imgs = fileList1S.map((e) => {
        // 0 是封面 1不是
        return {
          url: e.url,
          isCoverSheet: 1,
          type: e.url.substring(e.url.lastIndexOf(".") + 1, e.url.indexOf("?")),
        };
      });
      obj.imgs[obj.imgs.length - 1].isCoverSheet = 0;
      Axios(
        "POST",
        "/material/material/equipment/sou",
        obj,
        false,
        function (res) {
          if (res.data.code == 200) {
            handleClose(true);
          } else {
            ElMessage.error(res.data.message);
          }
        }
      );
      // obj.imgs = list.value;
      // console.log(obj);
    } else {
      return false;
    }
  });
};
const handleClose = function (e) {
  form.value = {
    contactInformation: "",
    coverSheet: "",
    name: null,
    description: "",
  };
  fileList.value = [];
  fileList1.value = [];
  checked.value = false;
  formRef.value.resetFields();
  e ? getList() : "";
};
getList();
</script>
<style lang="less" scoped>
/deep/ .img-text {
  display: none;
}

.body_top {
  margin: 0 auto;
  position: relative;
  background: rgba(0, 0, 0, 0.3);
}

.body_main {
  display: block;
  width: 12.8rem;
  margin: 0 auto;
}

.bg_img_div {
  width: 100%;
  position: relative;
  // z-index: -1;
  // background: rgba(0, 0, 0, 0.3);
  // overflow: hidden;
  background: url('../../assets/newYXSCbg22.png') no-repeat bottom center;
  background-size: auto 100%;
  height: 7rem;
  position: relative;
}

.bg_img_div>img {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.body_top_abs {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
}

.body_top_abs>.img_he {
  flex: 1;
  position: relative;
  width: 100%;
  text-align: center;
  margin-top: 1.3rem;
}

.log_Img {
  text-align: center;
  width: 2.8rem;
}

.bt1 {
  margin-top: 0.1rem;
  color: #ffffff;
  font-size: 0.3rem;
  text-align: center;
}

.bt2 {
  margin-top: 0.08rem;
  font-size: 0.16rem;
  color: #ffffff;
  text-align: center;
}

.ag_select {
  margin-bottom: 0.12rem;
}

.ag_select>span {
  margin-right: 0.4rem;
  color: #fff;
  font-size: 0.14rem;
  line-height: 0.16rem;
  padding-bottom: 0.03rem;
}

.ag_selectT {
  border-bottom: 0.02rem solid #fff;
}

.ag_selectY {
  border-bottom: 0.02rem solid rgba(0, 0, 0, 0);
}

.ag_l {
  width: 100%;
  display: flex;
  justify-content: initial;
  align-items: center;
}

.ss_abs_c_srk {
  width: 8rem;
  display: flex;
  overflow: hidden;
  border-radius: 0.08rem;
}

.ss_abs_c_srk>input {
  flex-grow: 1;
  font-size: 0.14rem;
  border: 0rem solid #fff;
  padding: 0.16rem;
}

.ss_abs_c_srk>div {
  font-size: 0.14rem;
  color: #ffffff;
  background: #C01A26;
  padding: 0.16rem 0.24rem;
  display: flex;
  align-items: center;
}

.ss_abs_c_srk>div>img {
  width: 0.16rem;
  margin-right: 0.06rem;
}

.ss_abs_c_srk>div>input {
  border: 0rem solid #fff;
  background: #fff;
}

.body_main_a {
  padding: 0.3rem 0.9rem;
  box-shadow: 0rem 0.04rem 0.12rem 0rem rgba(190, 198, 210, 0.25);
  border-radius: 0.12rem;
  background: #ffffff;
}

.body_main_a,
.body_main_a_left,
.body_main_a_left>div {
  display: flex;
  justify-content: space-between;
}

.body_main_a_left>div {
  align-items: center;
  margin-right: 0.2rem;
}

.body_main_a_left>div>img {
  width: 0.32rem;
  margin-right: 0.09rem;
}

.body_main_a_left>div>div {
  color: #333333;
  font-size: 0.16rem;
}

.body_main_a_right {
  padding: 0.04rem 0.12rem;
  border-radius: 1rem;
  background: linear-gradient(171deg, #fbe7ce 0%, #fed79e 100%);
  color: #785935;
  font-size: 0.14rem;
  display: flex;
  align-items: center;
}

.body_main_a_right>img {
  width: 0.3rem;
}

.ss_abs_center {
  display: flex;
  justify-content: center;
  width: 100%;
  align-items: center;
  margin-top: 0.8rem;
}

.ss_abs_c_srk {
  width: 6rem;
  display: flex;
  overflow: hidden;
  border-radius: 0.08rem;
}

.ss_abs_c_srk>input {
  flex-grow: 1;
  font-size: 0.14rem;
  border: 0rem solid #fff;
  padding: 0.16rem;
}

.ss_abs_c_srk>div {
  font-size: 0.14rem;
  color: #ffffff;
  background: #C01A26;
  padding: 0.16rem 0.24rem;
  display: flex;
  align-items: center;
}

.ss_abs_c_srk>div>img {
  width: 0.16rem;
  margin-right: 0.06rem;
}

.ss_abs_c_srk>div>input {
  border: 0rem solid #fff;
  background: #fff;
}

.ss_abs_c_center {
  margin: 0 0.16rem;
  font-size: 0.14rem;
  color: #fff;
}

.ss_abs_c_right {
  background: #C01A26;
  color: #fff;
  padding: 0.16rem 0.24rem;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  font-size: 0.14rem;
}

.log_box {
  position: absolute;
  bottom: 0.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 0.78rem;
  width: 100%;

  img {
    // width: 1.2rem;
    height: 0.4rem;

    &:nth-of-type(2) {
      margin: 0 0.24rem;
    }
  }

  p {
    padding: 0 0.21rem;
    color: #fff;
  }
}

.moduleImageList {
  width: 12rem;
  margin: 0 auto;
  margin-top: 0.65rem;
}

.img-Off {
  position: absolute;
  left: 120px;
  top: -10px;
  width: 40px;
  height: 40px;
}

.img-text {
  position: absolute;
  /* left:100px; */
  bottom: 0px;
  text-align: center;
  font-size: 10px;
  width: 150px;
  background: rgba(0, 0, 0, 0.2);

  /* left: 0px; */
}

.img-Off1 {
  position: absolute;
  left: 0.5rem;
  top: -10px;
  width: 40px;
  height: 40px;
  z-index: 5;
}

.dataBtn {
  width: 0.88rem;
  padding: 0.08rem 0.16rem;
  background: #C01A26;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  opacity: 1;
  text-align: center;
  font-size: 0.14rem;
  color: #fff;
}

.dataBtnQx {
  margin-right: 0.2rem;
  border: 1px solid #86909c;
  color: #333333;
  background: transparent;
}

/deep/.el-upload-dragger {
  border: 0;
}

/deep/ input[type="file"] {
  display: none;
}

/deep/ .el-upload__input {
  display: none;
}

/deep/ .el-upload-dragger {
  background: #f5f5f5;
  width: 2rem;
  height: 2rem;
}

.he {
  // margin-left: 10px;

  .he1 {
    position: relative;

    .he2 {
      position: relative;

      /deep/ .el-image__inner {
        height: 100%;
        width: 100%;
      }

      .el-image {
        margin-left: 20px;
      }
    }

    /deep/ .el-image__inner {
      // height: 100%;
      // width: 92%;
    }

    .img {
      width: 0.8rem;
      height: 0.8rem;
    }
  }

  // .img1 {
  //   width: 0.8rem;
  //   height: 0.8rem;
  // }
  /deep/ .el-upload {
    --el-upload-dragger-padding-horizontal: 0;
  }
}

.img_he1 {
  height: 0.8rem;
  width: 0.8rem;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
}

// .el-image {
//   // &:nth-of-type(0) {
//   //   margin-left: 10px;
//   // }

//   // &:nth-of-type(2) {
//   //   margin-left: 10px;
//   // }
//   // &:nth-of-type(3) {
//   //   margin-left: 10px;
//   // }
// }
</style>
